/*(function () {
  // Cada vez que se hace click en un pagination-link, actualizamos la URL del navegador
  document.addEventListener('click', function (e) {
    const paginationLink = e.target.closest('pagination-link');
    if (!paginationLink) return;

    const url = paginationLink.dataset.url;
    if (!url) return;

    // Actualizar la URL del navegador sin recargar la página
    history.replaceState(null, '', url);
  });
})();*/

(function () {
  document.addEventListener('click', function (e) {
    const paginationLink = e.target.closest('pagination-link');
    if (!paginationLink) return;

    const url = paginationLink.dataset.url;
    if (!url) return;

    // pushState en lugar de replaceState → crea entrada en el historial
    history.pushState(null, '', url);
  });
})();

